import { Component, OnInit } from '@angular/core';

import { LoaderService } from '@core/services/loader.service';

@Component({
  selector: 'loader',
  template: `
    <div *ngIf="show" id="loaderId" class="custom-overlay active">
      <!---Add Class: active to show-->
      <div class="loading">
        <svg
          version="1.1"
          width="40"
          height="40"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 48 48"
          style="enable-background:new 0 0 48 48;"
          xml:space="preserve"
        >
          <path
            style="fill:#F58220;"
            d="M21,4.2C12.4,5.4,5.6,12.2,4.3,20.8H1.5C2.8,10.7,10.8,2.6,21,1.3L21,4.2z"
          />
          <path
            style="fill:#39B54A;"
            d="M26.6,4.2c8.6,1.2,15.4,8.1,16.7,16.7h2.8C44.9,10.7,36.8,2.6,26.6,1.3V4.2z"
          />
          <path
            style="fill:#c7a6a7;"
            d="M21,43.1c-8.6-1.2-15.4-8.1-16.7-16.7H1.5C2.8,36.6,10.8,44.7,21,46L21,43.1z"
          />
          <path
            style="fill:#00B8A5;"
            d="M26.6,43.1c8.6-1.2,15.4-8.1,16.7-16.7h2.8C44.9,36.6,36.8,44.7,26.6,46V43.1z"
          />
          <circle style="fill:#6F2C91;" cx="23.8" cy="23.7" r="5.6" />
        </svg>
        <span>Processing...</span>
      </div>
    </div>
  `,
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  show: boolean;
  constructor(private _loaderService: LoaderService) {}

  ngOnInit() {
    this._loaderService.loadState.subscribe(res => {
      this.show = res;
    });
  }
}
